// Google Analytics integration
type GtagArgs = [string, ...unknown[]];

declare global {
  interface Window {
    gtag?: (...args: GtagArgs) => void;
    _gaq?: unknown[];
    dataLayer?: unknown[];
  }
}

export const initializeAnalytics = (trackingId: string) => {
  if (!trackingId) return;

  // Load Google Analytics script
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${trackingId}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag(...args: GtagArgs) {
    if (window.dataLayer) {
      window.dataLayer.push(args);
    }
  }
  window.gtag = gtag;

  gtag('js', new Date());
  gtag('config', trackingId);
};

export const trackEvent = (category: string, action: string, label?: string) => {
  if (window.gtag) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
    });
  } else if (window._gaq) {
    // Fallback for old GA
    window._gaq.push(['_trackEvent', category, action, label]);
  }
};

export const trackPageView = (path: string) => {
  if (window.gtag) {
    window.gtag('config', 'GA_MEASUREMENT_ID', {
      page_path: path,
    });
  }
};

